import {
  AHText,
  AHTextFonts,
  Box,
  useLayoutContext,
  useScaleFactor,
} from "arkh";
import React, { PropsWithChildren, useMemo } from "react";
import { StyleProp, View, ViewStyle } from "react-native";

export function GraphContainer(
  props: PropsWithChildren<{ hasGoals?: boolean }>
) {
  return (
    <Box
      spaceBottom="medium"
      spaceRight="small"
      spaceLeft={props.hasGoals ? "xsmall" : "small"}
      style={{ flexDirection: "row", flex: 1, height: "100%" }}
    >
      {props.children}
    </Box>
  );
}

export function WidgetTaskSingleGraphOccasion(
  props: PropsWithChildren<{ style?: StyleProp<ViewStyle> }>
) {
  return (
    <Box
      style={[
        {
          flex: 1,

          alignContent: "center",
          alignItems: "center",
          justifyContent: "flex-end",
        },
        props.style,
      ]}
    >
      {props.children}
    </Box>
  );
}

export function GraphValueText(props: {
  children: string;
  emphasis?: boolean;
}) {
  return (
    <AHText
      size={8}
      color={props.emphasis ? "darkerText" : "darkText"}
      font={props.emphasis ? AHTextFonts.BOLDER : undefined}
      spaceBottom="xxsmall"
      style={{
        textAlign: "center",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
      }}
      numberOfLines={1}
      ellipsizeMode="clip"
      type="detail"
    >
      {props.children}
    </AHText>
  );
}

export function GraphBar(props: {
  height: number;
  valueText?: string;
  emphasis?: boolean;
  parts: { color: string; weight: number }[];
}) {
  return (
    <Box
      style={{
        width: "100%",
        flex: 1,
        justifyContent: "flex-end",
        alignContent: "center",
      }}
    >
      {props.valueText ? (
        <GraphValueText emphasis={props.emphasis}>
          {props.valueText ?? ""}
        </GraphValueText>
      ) : null}
      <BarContent parts={props.parts} height={props.height} />
    </Box>
  );
}

function Part(props: {
  weight: number;
  i: number;
  color: string;
  fullHeight: number;
}) {
  const style: StyleProp<ViewStyle> = useMemo(
    () => ({
      backgroundColor: props.color,
      height: Math.round(props.fullHeight * props.weight),
      overflow: "hidden",
    }),
    [props.color, props.fullHeight, props.weight]
  );

  return <View style={style} />;
}
function BarContentC(props: {
  height: number;
  parts: { weight: number; color: string }[];
}) {
  const layout = useLayoutContext();
  const sf = useScaleFactor();

  const style: StyleProp<ViewStyle> = useMemo(
    () => ({
      marginLeft: layout.space.xsmall * sf,
      marginRight: layout.space.xsmall * sf,
      justifyContent: "flex-end",
      height: props.height,
      overflow: "hidden",
      borderRadius: layout.radius.small * sf,
    }),
    [layout.radius.small, layout.space.xsmall, props.height, sf]
  );
  const parTotal = props.parts.reduce((acc, cur) => acc + cur.weight, 0);
  return (
    <View style={style}>
      {props.parts.map((p, i) => (
        <Part
          i={i}
          fullHeight={props.height}
          weight={parTotal === 0 ? 0 : p.weight / parTotal}
          color={p.color}
          key={i}
        />
      ))}
    </View>
  );
}
export const BarContent = React.memo(BarContentC);

export function GraphLabel(
  props: PropsWithChildren<{
    active?: boolean | undefined;
  }>
) {
  const sf = useScaleFactor();

  return (
    <View
      style={{
        height: 20 * sf,
        justifyContent: "flex-end",
      }}
    >
      <AHText
        color={props.active ? "darkerText" : "washedText"}
        font={props.active ? AHTextFonts.BOLDER : undefined}
        style={{
          textAlign: "center",
          justifyContent: "center",
          alignContent: "center",
          alignItems: "center",
        }}
        type="detail"
      >
        {props.children}
      </AHText>
    </View>
  );
}
